module.exports = __webpack_public_path__ + "static/media/drone2.a236cbc6.png";